import { Context } from '@nuxt/types';

export default async function (context: Context) {
  const domainConfig = context.$config?.domainConfig ?? {};
  const gtmId = domainConfig.googleTagManagerId;
  const pageLanguage = context.i18n.locale;
  context.store.dispatch('gtm-init/setGtmId', gtmId);
  context.store.dispatch('gtm-init/setPageLanguage', pageLanguage);
}
